import {
  createReqConsts,
  createActions,
  createReqWatcher,
  createReqReducer,
} from '../../utils/redux';

export const consts = createReqConsts('profile', 'edit-working-hours');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'employee_profiles',
  type: 'put',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/profiles/edit-working-hours.js